import { Component, OnInit } from '@angular/core';
import { NbMenuItem } from '@nebular/theme';

@Component({
  selector: 'ngx-hm-header',
  templateUrl: './hm-header.component.html',
  styleUrls: ['./hm-header.component.scss']
})
export class HmHeaderComponent implements OnInit {

  isCollapsed: boolean = true;

  items: NbMenuItem[] = [{
    title: 'Celiachia',
    url: 'https://celiachia.sanita.toscana.it',
    icon: 'fa-question-circle-o',
    target: '_blank'
  },
  {
    title: 'ZERO Code',
    url: 'https://zerocode.sanita.toscana.it',
    icon: 'fa-question-circle-o',
    target: '_blank'
  },
  {
    title: 'Televisita',
    url: 'https://televisita.sanita.toscana.it',
    icon: 'fa-question-circle-o',
    target: '_blank'
  },
  {
    title: 'CUP online',
    url: 'https://prenota.sanita.toscana.it',
    icon: 'fa-question-circle-o',
    target: '_blank'
  },
  {
    title: 'Fascicolo sanitario',
    url: 'https://fascicolosanitario.regione.toscana.it/',
    icon: 'fa-question-circle-o',
    target: '_blank'
  }];

  constructor() { }

  ngOnInit() {
  }

}
